
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { IRouteMeta } from "@/router/interface";
import program_routes from "@/api/routes/programs";

import { normalizedProgramVersionStatusBadgeColor } from "@/helpers";

import Preloader from "@/components/Preloader.vue";
import CInfiniteScroll from "@/components/InfiniteScroll.vue";

import { IProgram } from "@/models/program/program";

interface IData {
  current_page: number;
  programs: IProgram[];
  next_page: boolean;
}

@Component({
  name: "CProgramListSearch",
  components: {
    Preloader,
    CInfiniteScroll
  }
})
export default class CProgramListSearch extends Vue {
  @Prop({ required: true }) private skill_category_id!: string | null;
  @Prop({ required: true }) private skill_id!: string | null;

  public search: string = this.$store.state.search;

  public normalizedProgramVersionStatusBadgeColor = normalizedProgramVersionStatusBadgeColor;

  public preload: boolean = false;
  private preload_infinite: boolean = false;

  private per_page: number = 100;
  private current_page: number = 0;
  private next_page: boolean = false;

  public programs: IProgram[] = [];

  private watchers: Function[] = [];

  protected beforeDestroy() {
    this.watchers.forEach(unwatch => {
      unwatch();
    });
  }

  protected async created() {
    this.watchers.push(
      this.$store.watch(
        state => state.search,
        async search => {
          this.search = search;

          await this.clearPrograms();
        }
      )
    );

    await this.clearPrograms();
  }

  @Watch("skill_id")
  protected async changeSkillId() {
    await this.clearPrograms();
  }

  @Watch("skill_category_id")
  protected async changeSkillCategoryId() {
    await this.clearPrograms();
  }

  public async infiniteHandler() {
    if (this.next_page && !this.preload_infinite) {
      await this.searchPrograms(this.current_page + 1);
    }
  }

  public async clearPrograms() {
    this.preload = true;

    this.programs = [];
    await this.searchPrograms();
  }

  private async searchPrograms(page: number = 0) {
    this.preload_infinite = true;

    return this.$api
      .get(program_routes.index_search, {
        params: {
          page,
          per_page: this.per_page,
          skill_id: this.skill_id,
          skill_category_id: this.skill_category_id,
          search: this.search,
          section_id: (this.$router.currentRoute.meta! as IRouteMeta)
            .permissions?.[0]
        }
      })
      .then(({ data: res }: { data: IData }) => {
        this.current_page = res.current_page;
        this.next_page = res.next_page;
        this.programs.push(...res.programs);
      })
      .finally(() => {
        this.preload = false;
        this.preload_infinite = false;
      });
  }
}
